import { createI18n, i18n as baseI18n } from '@hilma/netina2all';

import stationSummaryManagementText from './stationSummaryManagementText';
import associationRegistrationText from './associationRegistrationText';
import stationRegistrationFormText from './stationRegistrationFormText';
import orderSummaryManagementText from './orderSummaryManagementText';
import associationManagementText from './associationManagementText';
import personalDetailsRulesText from './personalDetailsRulesText';
import purchaseAssociationText from './purchaseAssociationText';
import { reviewedDeliveryText } from './ReviewedDeliveryText';
import purchaseAtonementText from './purchaseAtonementText';
import profileNavigationText from './profileNavigationText';
import stationManagementText from './stationManagementText';
import associationRulesText from './associationRulesText';
import stationPurhcasesText from './stationPurchasesText';
import siteIsClosedBanner from './siteIsCosedBannerText';
import personalDetailsText from './personalDetailsText';
import purchaseStationText from './purchaseStationText';
import contactUsRulesText from './contactUsRulesText';
import changeStationText from './changeStationText';
import advertisementText from './advertisementText';
import stationRulesText from './stationRulesText';
import distStationsText from './distStationsText';
import pageNotFoundText from './pageNotFoundText';
import orderSummaryText from './orderSummaryText';
import associationText from './associationsText';
import purchaseKitText from './purchaseSetText';
import howItWorksText from './howItWorksText';
import helmetResource from './helmetResource';
import contactUsText from './contactUsText';
import countdownText from './countdownText';
import homePageText from './homePageText';
import purchaseText from './purchaseText';
import whoWeAreText from './whoWeAreText';
import freeSaleText from './freeSaleText';
import commonQText from './commonQText';
import generalText from './generalText';
import sideBarText from './sideBarText';
import footerText from './footerText';
import topbarText from './topbarText';
import tableText from './tableText';
import unsubText from './unsubText';
import errText from './errText';
import payment from './payment';
import login from './login';
import alts from './alts';

const i18n = createI18n({
	...baseI18n,
	alts,
	login,
	errText,
	payment,
	countdownText,
	us: unsubText,
	p: purchaseText,
	cq: commonQText,
	table: tableText,
	wwa: whoWeAreText,
	topbar: topbarText,
	footer: footerText,
	ps: purchaseKitText,
	hiw: howItWorksText,
	general: generalText,
	sideBar: sideBarText,
	conUs: contactUsText,
	asso: associationText,
	at: advertisementText,
	pnf: pageNotFoundText,
	cs: changeStationText,
	pSum: orderSummaryText,
	freeSale: freeSaleText,
	helmet: helmetResource,
	pd: personalDetailsText,
	pSt: purchaseStationText,
	sp: stationPurhcasesText,
	rdT: reviewedDeliveryText,
	pa: purchaseAtonementText,
	sm: stationManagementText,
	homePageText: homePageText,
	stationRl: stationRulesText,
	cntctRl: contactUsRulesText,
	pNav: profileNavigationText,
	pAs: purchaseAssociationText,
	assoRl: associationRulesText,
	am: associationManagementText,
	pdr: personalDetailsRulesText,
	distStations: distStationsText,
	siteIsClosed: siteIsClosedBanner,
	assoReg: associationRegistrationText,
	stationReg: stationRegistrationFormText,
	pSumManagement: orderSummaryManagementText,
	stationsManagement: stationSummaryManagementText,
});

export default i18n;